
import styled from "styled-components";
import { footer_logo, ferpa } from "../../assets/images";


function Footer() {
  const quickLinksData = {
    title: "Quick Links",
    links: [
      { text: "Home", href: "/" },

      { text: "Blogs", href: "/blogs/ai-lms" },
      { text: "Contact Us", href: "/contact" }
    ]
  };

  const legalLinksData = {
    title: "Legal",
    links: [
      { text: "Terms & Conditions", href: "/terms" },
      { text: "Privacy Policy", href: "/privacy" }
    ]
  };

  return (
    <FooterContainer>
      <MainContent>
        <ContentWrapper>
          <BrandContainer>
            <BrandLogo
              src={footer_logo}
              alt="Campus Insights Logo"
            />
            <BrandDescription>
              We partner with colleges to transform the student journey from
              enrollment to graduation.
            </BrandDescription>
          </BrandContainer>
          <NavigationWrapper>

            <NavigationContainer>
              <NavigationTitle>{quickLinksData.title}</NavigationTitle>
              {quickLinksData.links.map((link, index) => (
                <NavigationLink
                  key={index}
                  href={link.href}
                  target={link.newTab ? "_blank" : "_self"}
                  rel={link.newTab ? "noopener noreferrer" : undefined}
                >
                  {link.text}
                </NavigationLink>
              ))}

            </NavigationContainer>

            <NavigationContainer>
              <NavigationTitle>{legalLinksData.title}</NavigationTitle>
              {legalLinksData.links.map((link, index) => (
                <NavigationLink key={index} href={link.href}>
                  {link.text}
                </NavigationLink>
              ))}
              <a href="https://studentprivacy.ed.gov/" target="_blank" rel="noopener noreferrer">
                <Image alt="Ferpa Logo" src={ferpa} />
              </a>
            </NavigationContainer>

          </NavigationWrapper>
        </ContentWrapper>
        <CopyrightContainer>
          <CopyrightText>
            © 2026 Campus Insights. All rights reserved.
          </CopyrightText>

          <SocialMediaIcons />
        </CopyrightContainer>
      </MainContent>
    </FooterContainer>
  );
}

function SocialMediaIcons() {


  return (
    <SocialMediaContainer>
      <svg
        width="184"
        height="40"
        viewBox="0 0 184 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Facebook */}
        <a
          href="https://www.facebook.com/profile.php?id=61573113310878"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Campus Insights Facebook"
        >
          <g style={{ cursor: "pointer" }}>
            <path d="M39.999 20C39.999 31.0459 31.0449 40 19.999 40C8.9541 39.999 0 31.0449 0 20C0 8.9541 8.9541 0 20 0C31.0459 0 40 8.9541 40 20H39.999Z" fill="#2F2FFF" />
            <path d="M25.9253 18.4479L25.5921 21.1235C25.5357 21.5705 25.1572 21.9067 24.7082 21.9067H20.3746V33.0935C19.9176 33.1348 19.4546 33.1559 18.9865 33.1559C17.9396 33.1559 16.9178 33.0512 15.9303 32.8519V21.9067H12.5973C12.2913 21.9067 12.0416 21.656 12.0416 21.349V18.0009C12.0416 17.6939 12.2913 17.4432 12.5973 17.4432H15.9303V12.4221C15.9303 9.34074 18.4177 6.84326 21.487 6.84326H25.3756C25.6816 6.84326 25.9313 7.09392 25.9313 7.40094V10.749C25.9313 11.0561 25.6816 11.3067 25.3756 11.3067H22.5973C21.3702 11.3067 20.3756 12.3053 20.3756 13.5385V17.4442H25.0424C25.578 17.4442 25.9917 17.9153 25.9263 18.4489L25.9253 18.4479Z" fill="white" />
          </g>
        </a>

        {/* Twitter */}
        <a
          href="https://x.com/CampusInsights_"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Campus Insights Twitter/X"
        >
          <g style={{ cursor: "pointer" }}>
            <path d="M88 20C88 31.0459 79.0459 40 68 40C56.9541 40 48 31.0459 48 20C48 8.9541 56.9541 0 68 0C79.0459 0 88 8.9541 88 20Z" fill="#333333" />
            <path d="M70.8863 18.1628L78.9767 9.5097H75.9044L69.5545 16.3025L64.6914 9.5097H56.288L64.7941 21.3921L56.288 30.4912H59.3602L66.1269 23.2534L71.3081 30.4912H79.7116L70.8863 18.1638V18.1628ZM60.6175 11.7344H63.5469L75.381 28.2645H72.4516L60.6175 11.7344Z" fill="white" />
          </g>
        </a>

        {/* LinkedIn */}
        <a
          href="https://www.linkedin.com/company/campusinsights/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Campus Insights Linkedin"
        >
          <g style={{ cursor: "pointer" }}>
            <path d="M135.999 20C135.999 31.0459 127.045 40 115.999 40C104.954 39.999 96 31.0449 96 20C96 8.9541 104.954 0 116 0C127.046 0 136 8.9541 136 20H135.999Z" fill="#0077B5" />
            <path d="M108.916 14.6527C110.338 14.6527 111.492 13.4994 111.492 12.0767C111.492 10.654 110.338 9.50073 108.916 9.50073C107.493 9.50073 106.34 10.654 106.34 12.0767C106.34 13.4994 107.493 14.6527 108.916 14.6527Z" fill="white" />
            <path d="M110.87 16.3701H106.961C106.855 16.3701 106.769 16.4561 106.769 16.5623V29.0568C106.769 29.163 106.855 29.2491 106.961 29.2491H110.87C110.976 29.2491 111.062 29.163 111.062 29.0568V16.5623C111.062 16.4561 110.976 16.3701 110.87 16.3701Z" fill="white" />
            <path d="M125.66 21.0921V28.3902C125.66 28.8623 125.273 29.2489 124.801 29.2489H122.225C121.753 29.2489 121.366 28.8623 121.366 28.3902V22.3796C121.366 21.1947 120.405 20.2334 119.22 20.2334C118.035 20.2334 117.074 21.1947 117.074 22.3796V28.3902C117.074 28.8623 116.687 29.2489 116.215 29.2489H113.639C113.167 29.2489 112.781 28.8623 112.781 28.3902V17.2276C112.781 16.7554 113.167 16.3689 113.639 16.3689H116.215C116.687 16.3689 117.074 16.7554 117.074 17.2276V17.7772C117.933 16.6648 119.354 15.9401 120.937 15.9401C123.307 15.9401 125.66 17.6574 125.66 21.0921Z" fill="white" />
          </g>
        </a>

        {/* Instagram */}
        <a
          href="https://www.instagram.com/campusinsightsai/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Campus Insights Instagram"
        >
          <g style={{ cursor: "pointer" }}>
            <path d="M184 20C184 31.0459 175.046 40 164 40C152.954 40 144 31.0459 144 20C144 8.9541 152.954 0 164 0C175.046 0 184 8.9541 184 20Z" fill="url(#paint0_linear_377_412)" />
            <path d="M169.427 9.50879H158.574C155.778 9.50879 153.51 11.7768 153.51 14.5732V25.4258C153.51 28.2223 155.778 30.4903 158.574 30.4903H169.427C172.223 30.4903 174.491 28.2223 174.491 25.4258V14.5732C174.491 11.7768 172.223 9.50879 169.427 9.50879ZM172.682 25.0634C172.682 27.0606 171.062 28.6813 169.065 28.6813H158.936C156.939 28.6813 155.318 27.0606 155.318 25.0634V14.9346C155.318 12.9374 156.939 11.3167 158.936 11.3167H169.065C171.062 11.3167 172.682 12.9374 172.682 14.9346V25.0634Z" fill="white" />
            <path d="M164.01 14.5732C161.015 14.5732 158.584 17.0042 158.584 19.999C158.584 22.9938 161.015 25.4248 164.01 25.4248C167.005 25.4248 169.436 22.9938 169.436 19.999C169.436 17.0042 167.005 14.5732 164.01 14.5732ZM164.01 23.6169C162.017 23.6169 160.392 21.9921 160.392 19.999C160.392 18.0058 162.017 16.3811 164.01 16.3811C166.003 16.3811 167.628 18.0058 167.628 19.999C167.628 21.9921 166.003 23.6169 164.01 23.6169Z" fill="white" />
            <path d="M169.798 15.297C170.398 15.297 170.883 14.8111 170.883 14.2118C170.883 13.6125 170.398 13.1266 169.798 13.1266C169.199 13.1266 168.713 13.6125 168.713 14.2118C168.713 14.8111 169.199 15.297 169.798 15.297Z" fill="white" />
          </g>
        </a>

        {/* Instagram Gradient */}
        <defs>
          <linearGradient
            id="paint0_linear_377_412"
            x1="150.654"
            y1="4.74935"
            x2="183.063"
            y2="41.925"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#4F5BD5" />
            <stop offset="0.264" stopColor="#962FBF" />
            <stop offset="0.447" stopColor="#D62976" />
            <stop offset="0.745" stopColor="#FA7E1E" />
            <stop offset="1" stopColor="#FEDA75" />
          </linearGradient>
        </defs>
      </svg>

    </SocialMediaContainer>
  );
}


const SocialMediaContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
`;

const NavigationContainer = styled.div`
  display: flex;
  width: 160px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;

  @media (max-width: 640px) {
    width: 100%;
    gap: 15px;
  }
`;

const NavigationTitle = styled.h3`
  color: #fff;
  letter-spacing: -0.18px;
  font: 700 18px/140% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;
`;

const Image = styled.img`
  width:184px;
  height:54px;
  color: #6078ffff;
`;

const NavigationLink = styled.a`
  color: #fff;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

const CopyrightContainer = styled.div`
  display: flex;
  padding: 26px 130px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  background-color: #191919;

  @media (max-width: 991px) {
    padding: 20px 60px;
    flex-direction: column;
    gap: 20px;
  }

  @media (max-width: 640px) {
    padding: 20px;
    gap: 20px;
  }
`;

const CopyrightText = styled.p`
  color: #fff;
  letter-spacing: -0.075px;
  font: 400 15px/140% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;

  @media (max-width: 640px) {
    text-align: center;
    font-size: 14px;
  }
`;


const BrandContainer = styled.section`
  display: flex;
  width: 337px;
  height: 217px;
  flex-direction: column;
  align-items: flex-start;
  gap: 22px;

  @media (max-width: 991px) {
    width: 100%;
    max-width: 500px;
    height: 147px;
  }

  @media (max-width: 640px) {
    height: 207px;
    width: 100%;
  }
`;

const BrandLogo = styled.img`
  width: 180px;
  height: auto;
  display: block;
`;

const BrandDescription = styled.p`
  color: #fff;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  margin: 0;
`;

const FooterContainer = styled.footer`
  width: 100%;
  height: 340px;
  flex-shrink: 0;
  background-color: rgba(16, 16, 16, 0.87);
`;

const MainContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  height: 340px;
`;

const ContentWrapper = styled.div`
  display: flex;
  height: 280px;
  padding: 36px 160px 40px 160px;
  justify-content: center;
  align-items: flex-start;
  gap: 85px;
  width: 100%;
  box-sizing: border-box;
  background-color: #2B2B2B;

  @media (max-width: 991px) {
    padding: 40px 60px 30px 60px;
    gap: 60px;
    flex-direction: column;
    height: auto;
  }

  @media (max-width: 640px) {
    padding: 30px 20px 20px 20px;
    gap: 10px;
  }
`;

const NavigationWrapper = styled.nav`
  display: flex;
  align-items: flex-start;
  gap: 109px;

  @media (max-width: 991px) {
    gap: 60px;
    width: 100%;
    justify-content: space-between;
  }

  @media (max-width: 640px) {
    gap: 40px;
    flex-direction: column;
  }
`;

export default Footer;
